import React, { useEffect, useState } from "react";
import Pagination from "../Pagination/Pagination";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { selectReport } from "../../app/features/scoutingReports/reportSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  getReportById,
  updateReport,
  updateReportAll,
} from "../../app/features/scoutingReports/reportAction";
import { selectUser } from "../../app/features/user/userSlice";

const formStyle = {
  maxWidth: "1100px",
  margin: "40px auto",
  padding: "32px 24px",
  background: "#f7f8fa",
  borderRadius: "8px",
  fontFamily: "Segoe UI, Arial, sans-serif",
  color: "#1a2330",
  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "24px 32px",
  alignItems: "start",
};

const labelStyle = {
  fontWeight: 600,
  fontSize: "15px",
  marginBottom: "6px",
  display: "block",
};

const inputStyle = {
  width: "100%",
  padding: "8px 10px",
  fontSize: "15px",
  border: "1px solid #cfd8dc",
  borderRadius: "4px",
  background: "#fff",
  marginBottom: "10px",
};

const textareaStyle = {
  ...inputStyle,
  minHeight: "80px",
  resize: "vertical",
};

const scoutingReportStyle = {
  ...textareaStyle,
  // minHeight: "110px",
    minHeight: "300px",
    fontWeight: 500,
  fontSize: "15px",
};

const navStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "32px",
};

const navBtnStyle = {
  border: "none",
  background: "#e3e7ed",
  color: "#1a2330",
  fontWeight: 600,
  fontSize: "15px",
  borderRadius: "4px",
  padding: "6px 14px",
  margin: "0 4px",
  cursor: "pointer",
};

export default function EditReportForm() {
  const { reports, success } = useSelector(selectReport);
  const [file, setFile] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [playerData, setPlayerData] = useState();
  const navigate = useNavigate();
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const { userToken } = useSelector(selectUser);
  const { report, reportLoading, reportSuccess, reportError } = useSelector(
    (state) => state.scoutingReports
  );
  const [changeReportData, setChangeReportData] = useState(false);
  const { singleReport } = useLocation().state || { singleReport: false };
  useEffect(() => {
    setTotalPages(reports.length);
  }, []);

  useEffect(() => {
    if (reports && !singleReport) {
      setPlayerData(reports.find((data) => data?.id == params.id));
    }
    if (singleReport && !playerData) {
      dispatch(getReportById({ token: userToken?.access, id: params.id }));
      setPlayerData(report);
    }
  }, [params.id, reports, singleReport, report]);

  const handleSave = async (e) => {
    e.preventDefault();
    const res = await dispatch(
      updateReport({ id: playerData.id, data: playerData })
    );
    if (currentPage < reports.length && res && !singleReport) {
      const nextIndex = currentPage; // currentPage is 1-based, so nextIndex is correct
      const nextReport = reports[nextIndex];
      if (nextReport) {
        navigate(`/scouting-reports/edit/${nextReport.id}`);
        setCurrentPage(currentPage + 1);
      }
    }
    if (singleReport && res) {
      navigate(`/scouting-reports/${params.id}`);
    }
  };

  const handleSaveAll = async (e) => {
    e.preventDefault();
    const ids = reports.map((report) => report.id);
    const res = await dispatch(
      updateReportAll({ ids, token: userToken?.access })
    );
    if (res) {
      navigate(`/scouting-reports`);
    }
  };

  const handleRevertChanges = () => {
    setChangeReportData(false);
    setPlayerData(report);
  };

  return (
    <form style={formStyle}>
      <h2
        style={{
          fontWeight: 700,
          fontSize: "40px",
          marginBottom: "24px",
          color: "#022142",
        }}
      >
        Report Edit
      </h2>
      <div style={gridStyle}>
        {/* Left column */}
        <div>
          <label style={labelStyle}>
            <span style={{ color: "#022142", fontSize: "20px" }}>
              Player Name
            </span>
            <span style={{ color: "#b0b0b0", fontWeight: 400 }}></span>
          </label>
          <input
            style={inputStyle}
            placeholder="Player's Name"
            value={playerData?.player_name || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, player_name: e.target.value });
            }}
          />

          <label style={labelStyle}>
            School <span style={{ color: "#b0b0b0", fontWeight: 400 }}></span>
          </label>
          <input
            style={inputStyle}
            placeholder="School"
            value={playerData?.school || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, school: e.target.value });
            }}
          />

          <label style={labelStyle}>
            Position <span style={{ color: "#b0b0b0", fontWeight: 400 }}></span>
          </label>
          <input
            style={inputStyle}
            placeholder="Position"
            value={playerData?.position || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, position: e.target.value });
            }}
          />

          <label style={labelStyle}>Height</label>
          <input
            style={inputStyle}
            placeholder={"6'02\" (example)"}
            value={playerData?.height || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, height: e.target.value });
            }}
          />

          <label style={labelStyle}>Weight</label>
          <input
            style={inputStyle}
            placeholder="202 lbs (example)"
            value={playerData?.weight || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, weight: e.target.value });
            }}
          />
        </div>

        {/* Right column */}
        <div>
          <label style={labelStyle}>
            <span style={{ color: "#022142", fontSize: "20px" }}>
              Scouting Report
            </span>
          </label>
          <textarea
            style={scoutingReportStyle}
            placeholder="Comprehensive evaluation of the player..."
            value={playerData?.scouting_report || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, scouting_report: e.target.value });
            }}
          />

      {/*    <label style={labelStyle}>Stats and Awards</label>*/}
      {/*    <label style={labelStyle}>Goals Scored</label>*/}
      {/*    <input*/}
      {/*      style={inputStyle}*/}
      {/*      placeholder="Goals Scored"*/}
      {/*      value={playerData?.goals_scored || ""}*/}
      {/*      onChange={(e) => {*/}
      {/*        setChangeReportData(true);*/}
      {/*        setPlayerData({ ...playerData, goals_scored: e.target.value });*/}
      {/*      }}*/}
      {/*    />*/}
      {/*    <label style={labelStyle}>Assists</label>*/}
      {/*    <input*/}
      {/*      style={inputStyle}*/}
      {/*      placeholder="Assists"*/}
      {/*      value={playerData?.assists || ""}*/}
      {/*      onChange={(e) => {*/}
      {/*        setChangeReportData(true);*/}
      {/*        setPlayerData({ ...playerData, assists: e.target.value });*/}
      {/*      }}*/}
      {/*    />*/}
      {/*    <label style={labelStyle}>Minutes Played</label>*/}
      {/*    <input*/}
      {/*      style={inputStyle}*/}
      {/*      placeholder="Minutes Played"*/}
      {/*      value={playerData?.minutes_played || ""}*/}
      {/*      onChange={(e) => {*/}
      {/*        setChangeReportData(true);*/}
      {/*        setPlayerData({ ...playerData, minutes_played: e.target.value });*/}
      {/*      }}*/}
      {/*    />*/}
      {/*    <label style={labelStyle}>Cups</label>*/}
      {/*    <input*/}
      {/*      style={inputStyle}*/}
      {/*      placeholder="Cups"*/}
      {/*      defaultValue={playerData?.cups || ""}*/}
      {/*      onChange={(e) => {*/}
      {/*        setChangeReportData(true);*/}
      {/*        setPlayerData({ ...playerData, cups: e.target.value });*/}
      {/*      }}*/}
      {/*    />*/}
        </div>
      </div>

      {/* Full width grid for the rest */}
      <div
        style={{
          ...gridStyle,
          marginTop: "18px",
          gridTemplateColumns: "1fr 1fr",
        }}
      >
        <div style={{ marginTop: "80px" }}>
          <label style={labelStyle}>
            <span style={{ color: "#022142", fontSize: "20px" }}>
              Strengths
            </span>
          </label>
          <textarea
            style={textareaStyle}
            placeholder="Strengths"
            value={playerData?.strengths || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, strengths: e.target.value });
            }}
          />
        </div>
        <div style={{ marginTop: "80px" }}>
          <label style={labelStyle}>
            <span style={{ color: "#022142", fontSize: "20px" }}>
              NFL Stylistic Comparison
            </span>
          </label>
          <input
            style={inputStyle}
            placeholder="NFL Stylistic Comparison"
            value={playerData?.nfl_comparison || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, nfl_comparison: e.target.value });
            }}
          />
        </div>
        <div>
          <label style={labelStyle}>Weaknesses</label>
          <textarea
            style={textareaStyle}
            placeholder="Weaknesses"
            value={playerData?.weaknesses || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, weaknesses: e.target.value });
            }}
          />
        </div>
        <div>
          <label style={labelStyle}>
            <span style={{ color: "#022142", fontSize: "20px" }}>
              How does he project to fit in with his new team?
            </span>
          </label>
          <input
            style={inputStyle}
            placeholder="Projection with new team"
            value={playerData?.team_fit || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, team_fit: e.target.value });
            }}
          />
        </div>
        <div>
          <label style={labelStyle}>Intangibles and Off-Field Red Flag</label>
          <textarea
            style={textareaStyle}
            placeholder="Intangibles and Off-Field Red Flag"
            value={playerData?.intangibles || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, intangibles: e.target.value });
            }}
          />
        </div>
        <div>
          <label style={labelStyle}>
            <span style={{ color: "#022142", fontSize: "20px" }}>
              Why (Insert prospect name) instead of (comparable prospect 1) or
              (comparable prospect 2)?
            </span>
          </label>
          <input
            style={inputStyle}
            placeholder="Comparison rationale"
            value={playerData?.comparison_reasoning || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({
                ...playerData,
                comparison_reasoning: e.target.value,
              });
            }}
          />
        </div>
        <div>
          <label style={labelStyle}>Ideal Scheme Fit, Role</label>
          <textarea
            style={textareaStyle}
            placeholder="Ideal Scheme Fit, Role"
            value={playerData?.ideal_scheme || ""}
            onChange={(e) => {
              setChangeReportData(true);
              setPlayerData({ ...playerData, ideal_scheme: e.target.value });
            }}
          />
        </div>
      </div>

      {/* Navigation */}
      {!singleReport && (
        <div style={navStyle}>
          <Pagination
            totalCount={totalPages}
            pageSize={1}
            currentPage={currentPage}
            onPageChange={(page) => {
              setCurrentPage(page);
              navigate(`/scouting-reports/edit/${reports[page - 1].id}`);
            }}
            next={() => {
              setCurrentPage(currentPage + 1);
              navigate(`/scouting-reports/edit/${reports[currentPage + 1].id}`);
            }}
            previous={() => {
              setCurrentPage(currentPage - 1);
              navigate(`/scouting-reports/edit/${reports[currentPage - 1].id}`);
            }}
          />
        </div>
      )}
      <div
        style={{
          width: "45%",
          textAlign: "center",
          margin: "auto",
          marginTop: "50px",
          marginBottom: "50px",
          color: "#555555",
          fontSize: "14px",
        }}
      >
        All advanced stats are courtesy Pro Football Focus or Football
        Outsiders. All traditional stats are courtesy of official team websites,
        NFLGSIS or CFB Stats. All RAS and athletic testing numbers are courtesy
        of DraftScout.com and Kent Lee Platte's RAS Football website.
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "2px",
          width: "max-content",
          margin: "auto",
        }}
      >
        <button
          style={{
            backgroundColor: "#022142",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer",
            margin: "auto",
            display: "block",
          }}
          onClick={handleSave}
        >
          {singleReport ? "Save" : "Save And Next"}
        </button>
        {!singleReport && (
          <button
            style={{
              backgroundColor: "#022142",
              color: "white",
              padding: "10px 20px",
              borderRadius: "5px",
              border: "none",
              cursor: `${changeReportData ? "not-allowed" : "pointer"}`,
              margin: "auto",
              display: "block",
              opacity: `${changeReportData ? "0.5" : "1"}`,
            }}
            onClick={handleSaveAll}
            disabled={changeReportData}
          >
            Save All
          </button>
        )}
        {changeReportData && (
          <button
            style={{
              backgroundColor: "#022142",
              color: "white",
              padding: "10px 20px",
              borderRadius: "5px",
              border: "none",
              cursor: "pointer",
              margin: "auto",
              display: "block",
            }}
            onClick={handleRevertChanges}
          >
            Revert Changes
          </button>
        )}
      </div>
    </form>
  );
}
